<template>
  <div class="row">
    <div class="small-12 columns">
      <h1>Add Engineering Branch</h1>
      <div class="row">
        <div class="small-3 columns">Name</div>
        <div class="small-9 columns">
          <input v-model="name" type="text" class="input-box-course-creators" />
        </div>
      </div>
      <div class="row">
        <div class="small-12 columns">
          <button class="button-green" @click="addNewEngineeringBranch">
            Add Engineering Branch
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      name: undefined,
    }
  },
  methods: {
    addNewEngineeringBranch() {
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}engbranch/`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: { name: this.name },
      }).then(() => {
        this.$router.push("/engineering-branches/")
      })
    },
  },
}
</script>
